export default {"src":"/_next/static/media/aidark.9b8bb1fd.svg","height":16,"width":19,"blurWidth":0,"blurHeight":0};